import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex group rounded overflow-hidden flex-col bg-gray-800 shadow md:col-span-2 text-white" }
const _hoisted_2 = { class: "overflow-hidden relative" }
const _hoisted_3 = { class: "absolute bg-gray-800 text-white text-sm inset-x-0 bottom-0 bg-opacity-60 py-1 px-3 flex justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex space-x-3 items-center"
}
const _hoisted_5 = { class: "h-16 flex flex-col justify-center flex-grow pr-3 py-3 md:p-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs pl-5 uppercase text-pink-400 font-bold leading-none" }, "Featured", -1)
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "pl-5 text-xl truncate leading-snug" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_image = _resolveComponent("b-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_performer_badge = _resolveComponent("performer-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      "enter-class": "transform opacity-0",
      "enter-active-class": "duration-500 delay-300 ease-in",
      "enter-to-class": "opacity-100",
      mode: "out-in",
      "leave-class": "opacity-100",
      "leave-active-class": "duration-500 ease-out",
      "leave-to-class": "transform opacity-0",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.scene)
          ? (_openBlock(), _createElementBlock("div", {
              key: `scene-${_ctx.index}`
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_router_link, {
                  to: `/scenes/${_ctx._scene.slug}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_image, {
                      src: _ctx._scene.background,
                      preset: "backgroundMedium",
                      class: "transform w-full h-72 object-cover transition ease-in-out duration-300 group-hover:scale-105",
                      alt: "",
                      loading: "lazy"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(_ctx._scene.dateFormatted), 1),
                  (_ctx._scene.site)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        (_ctx._scene.siteIcon)
                          ? (_openBlock(), _createBlock(_component_b_image, {
                              key: 0,
                              src: _ctx._scene.siteIcon,
                              class: "h-3"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: `/sites/${_ctx._scene.site.short_name}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx._scene.site.name), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: `/scenes/${_ctx._scene.slug}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx._scene.title), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._scene.limitedPerformers, (performer) => {
                      return (_openBlock(), _createBlock(_component_performer_badge, {
                        key: `performer-${performer.id}`,
                        dark: "",
                        "performer-site": performer
                      }, null, 8, ["performer-site"]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}